export default function isString(a) {
  return typeof a == "string";
}